import { isEqual } from 'lodash';

export default {
  components: {
    InvoiceLineForm: () => import('../../forms/Invoices/InvoiceLineForm'),
    InvoiceEntityLineForm: () =>
      import('../../forms/Invoices/InvoiceEntityLineForm')
  },

  props: {
    line: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      valid: false,
      localLine: {}
    };
  },

  computed: {
    isTask() {
      return Boolean(this.line.entity_id);
    },
    componentName() {
      return this.isTask ? 'InvoiceEntityLineForm' : 'InvoiceLineForm';
    }
  },

  watch: {
    line: {
      deep: true,
      immediate: true,
      handler: function(prop) {
        if (isEqual(prop, this.localLine)) {
          return;
        }

        this.localLine = {
          ...this.localLine,
          ...prop
        };
      }
    }
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    }
  }
};
